import './config-amplify'
import './i18n'
import React from 'react'
import { render } from 'react-dom'
import App from './App'
import Loading from './components/Loading'
import { PersistGate } from 'redux-persist/integration/react'
import store, { history, persistor } from './store'
import { Provider } from 'react-redux'
import CssBaseline from '@material-ui/core/CssBaseline'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter as Router } from 'react-router-dom'
import MentorshipRoutes from 'Mentorship/Routes'
import RootErrorBoundary from 'core/RootErrorBoundary'
import './index.scss'
import { ThemeProvider } from '@material-ui/styles'
import { muiTheme } from 'legacy-theme'

// Initialize New Relic Browser Agent
import { BrowserAgent } from '@newrelic/browser-agent/dist/cjs/index'
import { shouldEnableNewRelic, getNewRelicConfig } from './newrelic/newrelic-config'
import { registerNewRelicAgent } from './newrelic/newrelic-telemetry'
import { publishBuildInfo } from './buildInfo'
import { startAppHealthMonitor } from './auth/appHealthMonitor'

publishBuildInfo()

if (shouldEnableNewRelic()) {
  const config = getNewRelicConfig()
  if (config) {
    registerNewRelicAgent(new BrowserAgent(config))
  }
}

startAppHealthMonitor(store.getState, history)

render(
  <ThemeProvider theme={muiTheme}>
    <CssBaseline />
    <RootErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          {
            // TODO research and fix this condition with better solution
            /\/mentorship\/feedback\/(\S+)$/gi.test(window.location.href) ? (
              <MentorshipRoutes />
            ) : (
              <Router>
                <App history={history} />
              </Router>
            )
          }
        </PersistGate>
      </Provider>
    </RootErrorBoundary>
  </ThemeProvider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
